module.exports = __webpack_public_path__ + "img/quiz.74857807.png";